import { render, staticRenderFns } from "./QuotationPreview.vue?vue&type=template&id=4cfa0482&scoped=true&"
import script from "./QuotationPreview.vue?vue&type=script&lang=ts&"
export * from "./QuotationPreview.vue?vue&type=script&lang=ts&"
import style0 from "./QuotationPreview.vue?vue&type=style&index=0&id=4cfa0482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa0482",
  null
  
)

export default component.exports